import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';

import { ModalSeleccionarClienteComponent } from './modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarClienteTiposComponent } from './modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component';
import { ModalSeleccionarProductoComponent } from './modal-seleccionar-producto/modal-seleccionar-producto.component';
import { ModalSeleccionarVendedorComponent } from './modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import { ModalSeleccionarPagoComponent } from './modal-seleccionar-pago/modal-seleccionar-pago.component';
import { ModalSeleccionarChequeComponent } from './modal-seleccionar-cheque/modal-seleccionar-cheque.component';
import { ModalSeleccionarProtestoComponent } from './modal-seleccionar-protesto/modal-seleccionar-protesto.component';
import { ModalSeleccionarProveedorComponent } from './modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { IptPanelComponent } from './ipt-panel/ipt-panel.component';
import { ModalVerErroresComponent } from './modal-ver-errores/modal-ver-errores.component';
import { ModalDocsReferenciaComponent } from './modal-docs-referencia/modal-docs-referencia.component';
import { ModalAddReferenciaComponent } from './modal-add-referencia/modal-add-referencia/modal-add-referencia.component';
import { ViewFoliosComponent } from '../shared/view-folios/view-folios.component';
import { ModalCargaMasivaComponent } from './modal-carga-masiva/modal-carga-masiva.component';
import { TablaViewClientesComponent } from './modal-carga-masiva/tabla-view-clientes/tabla-view-clientes.component';
import { TablaViewMaquinasComponent } from './modal-carga-masiva/tabla-view-maquinas/tabla-view-maquinas.component';

@NgModule({
  declarations: [
    ModalSeleccionarClienteComponent,
    ModalSeleccionarClienteTiposComponent,
    ModalSeleccionarProductoComponent,
    ModalSeleccionarVendedorComponent,
    ModalSeleccionarPagoComponent,
    ModalSeleccionarChequeComponent,
    ModalSeleccionarProtestoComponent,
    ModalSeleccionarProveedorComponent,
    ModalDocsReferenciaComponent,
    IptPanelComponent,
    ModalVerErroresComponent,
    ModalAddReferenciaComponent,
    ViewFoliosComponent,
    ModalCargaMasivaComponent,
    TablaViewClientesComponent,
    TablaViewMaquinasComponent,
  ],
  imports: [CommonModule, ToastModule.forRoot(), MDBBootstrapModulesPro.forRoot(), Ng9RutModule, FormsModule, ReactiveFormsModule, SharedModule],
  exports: [
    ModalSeleccionarClienteComponent,
    ModalSeleccionarClienteTiposComponent,
    ModalSeleccionarProductoComponent,
    ModalSeleccionarVendedorComponent,
    ModalSeleccionarPagoComponent,
    ModalSeleccionarChequeComponent,
    ModalSeleccionarProtestoComponent,
    ModalSeleccionarProveedorComponent,
    ModalDocsReferenciaComponent,
    IptPanelComponent,
    ModalVerErroresComponent,
    ViewFoliosComponent,
    ModalCargaMasivaComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedViewsModule {}
